<script>

    import IconAccessibility from "./icons/IconAccessibility.svelte";
    import IconLink from "./icons/IconLink.svelte";
    export let database;

</script>

{#if database.database_accessibility || database.link_instructions }
<div class="card-footer bg-transparent">
<span class="d-flex justify-content-between">
            {#if database.database_accessibility }
                <span class="tag">
                    <IconAccessibility
                            width="1rem"
                            height="1rem"
                            fill="--color-primary";
                            padding="--padding-form" />
                    <a href="{database.database_accessibility}"
                       target="_blank"
                       aria-label="Accessibility Information for {database.title}"
                    >&nbsp;
                        {#if database.vendor.some(vendor => vendor.name)}
                        {database.vendor[0].name}&nbsp;
                    {/if}Accessibility Information
                    </a>
                </span>
            {/if}
        {#if database.link_instructions || database.vendor.some(link => link.link_instructions)}
            <!-- Bind the database object to the click event handler -->
            <button class="tag"
                    aria-label="linking information"
                    on:click
            >
                <IconLink
                        width="1rem"
                        height="1rem"
                        fill="--color-primary";
                        padding="--padding-form"/> How to link to content
            </button>
            {/if}
   </span>
</div>
{/if}

<style>
    button {
        width: fit-content;
        padding: 0;
        background-color: transparent;
        color: var(--color-primary);
        text-decoration: none;
        border: 0;
    }

    button:hover {
        text-decoration: underline;
    }
</style>